import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=927319ee&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=927319ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927319ee",
  null
  
)

export default component.exports